import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import React from 'react'
import { CookiesProvider, useCookies } from 'react-cookie'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { Footer } from './components/shared/Footer'
import { Header } from './components/shared/Header'
import { Loading } from './components/shared/Loading'
import { MainSidebar } from './components/shared/MainSidebar'
import { UserProvider, useUser } from './contexts/User'
import AuthRouter from './routing/Auth'
import AppRouter from './routing/index'
import LookerRouter from './routing/Looker'
import './styles/global.scss'
import './localization'


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)


const AppWithContexts = () => {
  const [cookies] = useCookies(['mainSidebarState'])
  const { isLoggedIn, userDataLoading } = useUser()

  return (
    <>
      {isLoggedIn ? (
        <MainSidebar />
      ) : (
        <Header />
      )}
      <div className={`page ${isLoggedIn && 'loggedIn'} ${cookies.mainSidebarState === 'opened' ? 'opened' : 'closed'}`}>
        <div className={'content'}>
        {/* README: If the user is in the Looker dashboard, render the LookerRouter
            This is temporary!! When the internal dashboard is ready, this will be removed */}
        {/* eslint-disable-next-line i18next/no-literal-string */}
        {window.location.pathname.includes('mission_dashboard') ? (
          <LookerRouter />
        ) : userDataLoading ? (
          <Loading />
          ) : (isLoggedIn ? (
            <AppRouter />
          ) : (
            <AuthRouter />
          )
          )}
        </div>
        <Footer />
      </div>
    </>
  )
}


root.render(
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <BrowserRouter>
        <ToastContainer />
        <UserProvider>
          <AppWithContexts />
        </UserProvider>
      </BrowserRouter>
    </CookiesProvider>
  </LocalizationProvider>
)
